import React, { FC, PropsWithChildren, ReactElement, useCallback, useState } from 'react';
import { Menu, MenuItem, Stack, Typography } from '@mui/material';
import { ReactComponent as ThreeDotsIcon } from '../../components/icons/threeDots.svg';
import { ProfileImage } from 'new/elements/ProfileImage';
import { Box } from 'new/elements/Box';

import styles from './wideCard.module.scss';

type Props = {
  name: string;
  status?: string;
  description?: string;
  current?: boolean;
  rightSlot?: ReactElement;
  menuActions: {
    label: string;
    onClick: string;
  }[];
};

const WideCard: FC<PropsWithChildren<Props>> = ({
  name,
  description,
  status,
  current,
  rightSlot,
  menuActions,
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement | HTMLElement>(null);
  const handleOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  }, []);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Box className={styles.container}>
      <Stack direction="row" justifyContent="space-between" spacing="16px">
        <Stack direction="row" gap="16px" alignItems="center">
          <ProfileImage fullName={name} />
          <Stack>
            <Typography variant="subtitle1">{name}</Typography>
            <Typography variant="body2">{description}</Typography>
          </Stack>
        </Stack>
        <Stack
          direction="row"
          spacing="16px"
          justifyContent="flex-end"
          alignItems="center"
          sx={{ width: '50%' }}
        >
          {rightSlot}
          {menuActions?.length > 0 ? (
            <>
              <ThreeDotsIcon onClick={handleOpen} />
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                {menuActions.map((action, index) => (
                  <MenuItem key={index} onClick={action.onClick}>
                    {action.label}
                  </MenuItem>
                ))}
              </Menu>
            </>
          ) : null}
        </Stack>
      </Stack>
    </Box>
  );
};

export default WideCard;
